import { Component, ElementRef, inject, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-tab-nav-item',
  imports: [NgTemplateOutlet, RouterModule],
  templateUrl: './tab-nav-item.component.html',
  styleUrl: './tab-nav-item.component.scss',
})
export class TabNavItemComponent {
  private el = inject(ElementRef);
  private ssrService = inject(SsrService);
  @Input() value: string = '';
  @Input() route?: string | any[];

  setActive(): void {
    if (this.ssrService.isServer()) return;
    const tabEl = document.querySelector('[data-tab-id="' + this.value + '"]');
    const parentEl = this.el.nativeElement.closest('.tab-nav');
    if (parentEl) {
      const active = parentEl.querySelector('.tab-nav__item--active');
      if (active) {
        active.classList.remove('tab-nav__item--active');
        const activeTab = active.getAttribute('data-tab-anchor');
        if (activeTab) {
          const activeTabEl = document.querySelector('[data-tab-id="' + activeTab + '"]');
          if (activeTabEl) activeTabEl.removeAttribute('data-tab-active');
        }
      }
    }
    if (tabEl) {
      const itemEl = this.el.nativeElement.querySelector('.tab-nav__item');
      itemEl.classList.add('tab-nav__item--active');
      tabEl.setAttribute('data-tab-active', 'true');
    }
  }

  ngAfterViewInit(): void {
    if (this.ssrService.isServer()) return;
    setTimeout(() => {
      const active = document.querySelector('[data-tab-id="' + this.value + '"][data-tab-active="true"]');
      if (active) this.setActive();
    }, 250);
  }
}
